import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Dialog, IconButton } from '@material-ui/core'
import { reduxForm, formValueSelector } from 'redux-form'

import SendIcon from '@material-ui/icons/Send'
import { FORM_CODIGO_CUPO } from '../../../../../config/forms'
import DetalleCodigoDeCupo from '../components/DetalleCodigoDeCupo'
import { ToastContainer } from 'react-toastify'
import { getCodigoDeCupo } from '../../../actions'
import { INTERVALO_CORTO } from '../../../../../config/settings'
import ConsultaPorCodigoDeCupo from '../../../components/ConsultaPorCodigoDeCupo'

const selector = formValueSelector(FORM_CODIGO_CUPO)

const ConsultaCodigoDeCupos = (props) => {
  const { codigoDeCupo } = props
  const [open, setOpen] = useState(false)
  const [seconds, setSeconds] = useState(0)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1)
      }
      if (seconds === 0 && loading) {
        clearInterval(interval)
        setLoading(false)
      }
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    const { codigo, change: formChange } = props
    setLoading(true)
    setSeconds(2)
    props.getCodigoDeCupo(codigo)
    formChange('codigoCupo', '')
  }

  const handleClose = () => { setOpen(false) }

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <form onSubmit={handleSubmit} className='form-consulta-cod-cupo'>
        <div style={{ display: 'flex', flexDirection: 'row' }}>

          <ConsultaPorCodigoDeCupo
            textLabel='Consultar código de cupo'
            disabled={loading}
          />
          <br />

          <IconButton
            style={{ margin: '3', outline: 'none' }}
            color='primary'
            disabled={loading}
            type='submit'
          >
            <SendIcon style={{ fontSize: '1.8rem' }} />
          </IconButton>
        </div>
      </form>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth='md'>
        <DetalleCodigoDeCupo codigo={codigoDeCupo} />
      </Dialog>

    </>
  )
}

const mapStateToProps = (state) => {
  return {
    codigo: selector(state, 'codigoCupo'),
    codigoDeCupo: state.cupos.codigoDeCupo
  }
}

const mapActionsToProps = {
  getCodigoDeCupo
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
const withReduxForm = reduxForm({
  form: FORM_CODIGO_CUPO,
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})

export default withRedux(withReduxForm(ConsultaCodigoDeCupos))
